'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.treeViewNodeShape = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwTreeViewNode = require('./CwTreeViewNode.scss');

var _CwTreeViewNode2 = _interopRequireDefault(_CwTreeViewNode);

var _CwFlexbox = require('../cwflexbox/CwFlexbox');

var _CwFlexbox2 = _interopRequireDefault(_CwFlexbox);

var _CwImage = require('../cwimage/CwImage');

var _CwImage2 = _interopRequireDefault(_CwImage);

var _CwLabel = require('../cwlabel/CwLabel');

var _CwLabel2 = _interopRequireDefault(_CwLabel);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwTreeViewNode = function CwTreeViewNode(props) {

  var getIcon = function getIcon() {
    if (props.children) {
      return _react2.default.createElement(_CwImage2.default, { cwId: props.cwId + '_icon', className: _CwTreeViewNode2.default.icon, src: props.value.isCollapsed ? props.expandIcon : props.collapseIcon });
    } else {
      return _react2.default.createElement('div', { className: _CwTreeViewNode2.default.icon });
    }
  };

  var getLabel = function getLabel() {
    return _react2.default.createElement(_CwLabel2.default, { cwId: props.cwId + '_label', className: (0, _classnames2.default)(_CwTreeViewNode2.default.label, (0, _defineProperty3.default)({}, _CwTreeViewNode2.default.itemSelected, props.value.isSelected)), value: props.value.name });
  };

  var handleClick = function handleClick() {
    props.onClick(props.value);
  };

  return _react2.default.createElement(
    'div',
    { 'data-cwid': props.cwId, className: _CwTreeViewNode2.default.wrap },
    _react2.default.createElement(
      _CwFlexbox2.default,
      {
        cwId: props.cwId + '_flexbox',
        onClick: handleClick,
        className: 'CwTreeViewNode-item',
        verticalAlign: true },
      getIcon(),
      getLabel()
    ),
    props.value.isCollapsed ? null : _react2.default.createElement(
      'div',
      { 'data-cwid': props.cwId + '_sub_tree', className: _CwTreeViewNode2.default.subTree },
      props.children
    )
  );
};

var treeViewNodeShape = exports.treeViewNodeShape = {
  /**
   * Id must be unique identifier
   */
  id: _propTypes2.default.string.isRequired,
  /**
   * Rendered text for node
   */
  name: _propTypes2.default.string.isRequired,
  /**
   * Determines if node is selected. Should be mutually exclusive
   */
  isSelected: _propTypes2.default.bool,
  /**
   * Determines if node is collapsed or expanded
   */
  isCollapsed: _propTypes2.default.bool
};

CwTreeViewNode.propTypes = {
  /**
   *  Connectwise element id to be used as unique identifier
   **/
  cwId: _propTypes2.default.string,
  /**
   * TreeViewNode layout data
   */
  value: _propTypes2.default.shape(treeViewNodeShape).isRequired,
  /**
   * Collapse icon to display when expanded for treeviewnode with children
   */
  collapseIcon: _propTypes2.default.string.isRequired,
  /**
   * Expand icon to display when collapsed for treeviewnode with children
   */
  expandIcon: _propTypes2.default.string.isRequired,
  /**
   * Fires whenever treeviewnode is clicked
   */
  onClick: _propTypes2.default.func.isRequired,
  /**
   * Nested treeviewnodes
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.element), _propTypes2.default.element])
};

exports.default = CwTreeViewNode;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwtreeview/CwTreeViewNode.js
// module id = 867
// module chunks = 10